<script>
export default {
  name: 'CommonTableComponent',
  props: {
    classWrapper: {
      type: String,
      default: 'table-responsive'
    },
    heightClass: {
      type: String,
      default: 'table-wrapper-300'
    },
    scrollAble : {
      type: Boolean,
      default: true,
    }
  }
}
</script>
<template>
  <div :class="[classWrapper, heightClass, scrollAble ? 'scroll' : 'unscroll']">
    <table class="table table-hover table-bordered align-middle table-centered table-nowrap mb-0 table-sm table-sm-not-header table-sticky-header">
      <slot></slot>
    </table>
  </div>
</template>
<style scoped lang="scss">
.table-sm-not-header thead th {
  padding: 0.75rem 0.75rem;
}
.table-sticky-header {
  thead th {
    position: sticky;
    top: -1px;
    z-index: 1;
  }
}
.table {
  th {
    vertical-align: middle;
  }
  td {
    word-break: break-word;
    white-space: pre-wrap;
  }
}
</style>
